import React from 'react';
import Icon from '../../../components/AppIcon';

const ComplianceInfo = () => {
  const complianceItems = [
    {
      title: 'Anti-Money Laundering (AML)',
      description: 'We comply with international AML regulations to prevent financial crimes and ensure secure transactions.',
      icon: 'ShieldCheck'
    },
    {
      title: 'Know Your Customer (KYC)',
      description: 'Identity verification processes protect both you and our platform from fraud and regulatory violations.',
      icon: 'UserCheck'
    },
    {
      title: 'Data Protection',
      description: 'Your personal and financial data is protected under GDPR and other privacy regulations.',
      icon: 'Database'
    },
    {
      title: 'Transaction Monitoring',
      description: 'All transactions are monitored for suspicious activity to ensure compliance and security.',
      icon: 'Eye'
    }
  ];

  const regulatoryBodies = [
    { name: 'Financial Conduct Authority (FCA)', code: 'UK' },
    { name: 'Financial Crimes Enforcement Network (FinCEN)', code: 'US' },
    { name: 'European Banking Authority (EBA)', code: 'EU' },
    { name: 'Australian Transaction Reports (AUSTRAC)', code: 'AU' }
  ];

  return (
    <div className="space-y-6">
      {/* Compliance Overview */}
      <div className="bg-card rounded-lg border border-border p-6">
        <div className="flex items-center mb-4">
          <Icon name="Scale" size={24} className="text-primary mr-3" />
          <h2 className="text-xl font-semibold text-foreground">Regulatory Compliance</h2>
        </div>
        <p className="text-muted-foreground mb-6">
          MoneyTransfer Pro operates under strict regulatory oversight to ensure the highest standards 
          of financial security and compliance with international money transfer regulations.
        </p>

        <div className="grid grid-cols-1 gap-4">
          {complianceItems?.map((item, index) => (
            <div key={index} className="p-4 bg-muted/30 rounded-lg border border-border/50">
              <div className="flex items-start space-x-3">
                <div className="w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center flex-shrink-0">
                  <Icon name={item?.icon} size={20} className="text-primary" />
                </div>
                <div>
                  <h3 className="font-medium text-foreground mb-1">{item?.title}</h3>
                  <p className="text-sm text-muted-foreground">{item?.description}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      {/* Regulatory Bodies */}
      <div className="bg-card rounded-lg border border-border p-6">
        <h3 className="text-lg font-semibold text-foreground mb-4 flex items-center">
          <Icon name="Building2" size={20} className="text-primary mr-2" />
          Regulated By
        </h3>
        <div className="space-y-3">
          {regulatoryBodies?.map((body, index) => (
            <div key={index} className="flex items-center justify-between p-3 bg-muted/20 rounded-md">
              <span className="text-sm text-foreground">{body?.name}</span>
              <span className="text-xs font-medium text-primary bg-primary/10 px-2 py-1 rounded">
                {body?.code}
              </span>
            </div>
          ))}
        </div>
      </div>
      {/* License Information */}
      <div className="bg-card rounded-lg border border-border p-6">
        <h3 className="text-lg font-semibold text-foreground mb-4 flex items-center">
          <Icon name="FileText" size={20} className="text-primary mr-2" />
          License Information
        </h3>
        <div className="space-y-4">
          <div className="flex justify-between items-center p-3 bg-success/10 rounded-md border border-success/20">
            <div>
              <div className="text-sm font-medium text-foreground">Money Service Business License</div>
              <div className="text-xs text-muted-foreground">License #: MSB-2024-001234</div>
            </div>
            <Icon name="CheckCircle" size={20} className="text-success" />
          </div>
          
          <div className="flex justify-between items-center p-3 bg-success/10 rounded-md border border-success/20">
            <div>
              <div className="text-sm font-medium text-foreground">Electronic Money Institution</div>
              <div className="text-xs text-muted-foreground">License #: EMI-2024-005678</div>
            </div>
            <Icon name="CheckCircle" size={20} className="text-success" />
          </div>
        </div>
      </div>
      {/* Contact Compliance */}
      <div className="bg-card rounded-lg border border-border p-6">
        <h3 className="text-lg font-semibold text-foreground mb-4 flex items-center">
          <Icon name="MessageSquare" size={20} className="text-primary mr-2" />
          Compliance Inquiries
        </h3>
        <p className="text-sm text-muted-foreground mb-4">
          For questions about our compliance procedures or regulatory matters, contact our compliance team.
        </p>
        <div className="flex items-center space-x-3">
          <Icon name="Mail" size={16} className="text-muted-foreground" />
          <span className="text-sm text-foreground">compliance@moneytransfer.com</span>
        </div>
      </div>
    </div>
  );
};

export default ComplianceInfo;